export const paymentConstants = {
  GET_PAYMENT_MODE_REQUEST: 'PAYMENT_GET_PAYMENT_MODE_REQUEST',
  GET_PAYMENT_MODE_SUCCESS: 'PAYMENT_GET_PAYMENT_MODE_SUCCESS',
  GET_PAYMENT_MODE_FAILURE: 'PAYMENT_GET_PAYMENT_MODE_FAILURE',

  GET_PURPOSE_REQUEST: 'PAYMENT_GET_PURPOSE_REQUEST',
  GET_PURPOSE_SUCCESS: 'PAYMENT_GET_PURPOSE_SUCCESS',
  GET_PURPOSE_FAILURE: 'PAYMENT_GET_PURPOSE_FAILURE',

  GET_SOURCE_REQUEST: 'PAYMENT_GET_SOURCE_REQUEST',
  GET_SOURCE_SUCCESS: 'PAYMENT_GET_SOURCE_SUCCESS',
  GET_SOURCE_FAILURE: 'PAYMENT_GET_SOURCE_FAILURE',

  NET_AMT: 'NET_AMT',
  TRANSFER_RATE: 'TRANSFER_RATE',
  CLEAR_TRANS_INFO: 'CLEAR_TRANS_INFO',
  CLEAR_BENEF_VALUES: 'CLEAR_BENEF_VALUES',
  CLEAR_LOADING: 'CLEAR_LOADING',
  SAVE_TO_CURRENCY: 'SAVE_TO_CURRENCY',

  GET_RELATIONSHIP_REQUEST: 'AMOUNT_GET_RELATIONSHIP_REQUEST',
  GET_RELATIONSHIP_SUCCESS: 'AMOUNT_GET_RELATIONSHIP_SUCCESS',
  GET_RELATIONSHIP_FAILURE: 'AMOUNT_GET_RELATIONSHIP_FAILURE',

  GET_REMIT_HISTORY_REQUEST: 'GET_REMIT_HISTORY_REQUEST',
  GET_REMIT_HISTORY_SUCCESS: 'GET_REMIT_HISTORY_SUCCESS',
  GET_REMIT_HISTORY_FAILURE: 'GET_REMIT_HISTORY_FAILURE',

  GET_REMIT_COUNTRY_REQUEST: 'GET_REMIT_COUNTRY_REQUEST',
  GET_REMIT_COUNTRY_SUCCESS: 'GET_REMIT_COUNTRY_SUCCESS',
  GET_REMIT_COUNTRY_FAILURE: 'GET_REMIT_COUNTRY_FAILURE',

  GET_REMIT_CURRENCY_REQUEST: 'GET_REMIT_CURRENCY_REQUEST',
  GET_REMIT_CURRENCY_SUCCESS: 'GET_REMIT_CURRENCY_SUCCESS',
  GET_REMIT_CURRENCY_FAILURE: 'GET_REMIT_CURRENCY_FAILURE',

  SAVE_REMIT_REQUEST: 'SAVE_REMIT_REQUEST',
  SAVE_REMIT_SUCCESS: 'SAVE_REMIT_SUCCESS',
  SAVE_REMIT_FAILURE: 'SAVE_REMIT_FAILURE',

  VALID_ID_REQUEST: 'VALID_ID_REQUEST',
  VALID_ID_SUCCESS: 'VALID_ID_SUCCESS',
  VALID_ID_FAILURE: 'VALID_ID_FAILURE',

  GET_TRANSACTION_SEARCH_REF_REQUEST: 'GET_TRANSACTION_REF_REQUEST',
  GET_TRANSACTION_SEARCH_REF_SUCCESS: 'GET_TRANSACTION_REF_SUCCESS',
  GET_TRANSACTION_SEARCH_REF_FAILURE: 'GET_TRANSACTION_REF_FAILURE',

  GET_TRANSACTION_CANCEL_REQUEST: 'GET_TRANSACTION_CANCEL_REQUEST',
  GET_TRANSACTION_CANCEL_SUCCESS: 'GET_TRANSACTION_CANCEL_SUCCESS',
  GET_TRANSACTION_CANCEL_FAILURE: 'GET_TRANSACTION_CANCEL_FAILURE',

  GET_DRAWING_BANK_REQUEST: 'GET_DRAWING_BANK_REQUEST',
  GET_DRAWING_BANK_SUCCESS: 'GET_DRAWING_BANK_SUCCESS',
  GET_DRAWING_BANK_FAILURE: 'GET_DRAWING_BANK_FAILURE',
};
